/**
 * Read a user-facing API error message.
 * Expects backend `response` to be a string on failure.
 */
export function formatApiErrorMessage(error, fallback) {
	if (!error) {
		return fallback;
	}

	if (typeof error === 'string') {
		const trimmed = error.trim();
		return trimmed && trimmed !== '[object Object]' ? trimmed : fallback;
	}

	const response = error.responseJSON && error.responseJSON.response;
	if (typeof response === 'string' && response.trim() && response !== '[object Object]') {
		return response.trim();
	}

	if (typeof error.message === 'string' && error.message.trim() && error.message !== '[object Object]') {
		return error.message.replace(/^Error:\s*/i, '').trim() || fallback;
	}

	if (error.status === 0) {
		return 'Network error while contacting the API. Please try again.';
	}

	return fallback;
}
